// @flow

import unifizeUser from "../index";
import ImageLabel from "src/components/user/ImageLabel";

export default unifizeUser(ImageLabel);
